import ToolsTabs from '@screens/lp-default/components/tools/components/tabs';
import * as Styles from '@screens/lp-default/components/tools/styles';

type Props = {
  id: string;
};

export default function Tools({ id }: Props) {
  return (
    <Styles.Container id={id} data-testid="tools">
      <Styles.Title>Qual o seu momento profissional? O Whitebook apoia todos.</Styles.Title>
      <ToolsTabs />
    </Styles.Container>
  );
}
